// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import ConsentController from "./consent_controller"
application.register("consent", ConsentController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import ImpressionController from "./impression_controller"
application.register("impression", ImpressionController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)
